import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BreadcrumbList } from './BreadcrumbList';

const SEO = ({ 
    title, 
    description, 
    keywords, 
    image, 
    url, 
    type = 'website',
    structuredData = null,
    breadcrumbs = [],
    noindex = false
}) => {
    const defaultTitle = 'Márcia Maio - Organização Pessoal';
    const defaultDescription = 'Márcia Maio - organização residencial. Especialista em organização funcional de casas reais para rotinas mais leves. Soluções práticas, produtos organizadores personalizados e consultorias.';
    const defaultImage = 'https://ecommerce-api-production-edba.up.railway.app/image/logo-png';
    const defaultUrl = 'https://www.marciamaio.pt';
    const defaultKeywords = 'Márcia Maio, organização pessoal, organização de casa, produtividade, casa organizada, vida organizada, loja online, artigos de organização';

    const seoTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;
    const seoDescription = description || defaultDescription;
    const seoImage = image || defaultImage;
    const seoUrl = url || defaultUrl;
    const seoKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;

    const breadcrumbStructuredData = breadcrumbs.length > 0 ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": item.url
        }))
    } : null;

    const defaultStructuredData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Márcia Maio",
        "url": "https://www.marciamaio.pt",
        "logo": "https://ecommerce-api-production-edba.up.railway.app/image/logo-png",
        "sameAs": [
            "https://www.instagram.com/marciamaio.organiza",
            "https://www.facebook.com/marciamaio.organiza"
        ],
        "description": "Márcia Maio - organização residencial. Especialista em organização funcional de casas reais para rotinas mais leves. Soluções práticas, produtos organizadores personalizados e consultorias.",
        "address": {
            "@type": "PostalAddress",
            "addressCountry": "PT"
        },
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "availableLanguage": ["Portuguese"]
        }
    };

    const combinedStructuredData = structuredData ? {
        "@context": "https://schema.org",
        "@graph": [
            structuredData,
            ...(breadcrumbStructuredData ? [breadcrumbStructuredData] : []),
            defaultStructuredData
        ]
    } : breadcrumbStructuredData ? {
        "@context": "https://schema.org",
        "@graph": [
            breadcrumbStructuredData,
            defaultStructuredData
        ]
    } : defaultStructuredData;

    return (
        <>
            <Helmet>
                <title>{seoTitle}</title>
                <meta name="description" content={seoDescription} />
                <meta name="keywords" content={seoKeywords} />
                {noindex && <meta name="robots" content="noindex, nofollow" />}
                
                <meta property="og:title" content={seoTitle} />
                <meta property="og:description" content={seoDescription} />
                <meta property="og:image" content={seoImage} />
                <meta property="og:url" content={seoUrl} />
                <meta property="og:type" content={type} />
                <meta property="og:site_name" content="Márcia Maio" />
                <meta property="og:locale" content="pt_PT" />
                
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={seoTitle} />
                <meta name="twitter:description" content={seoDescription} />
                <meta name="twitter:image" content={seoImage} />
                <meta name="twitter:site" content="@marciamaio" />
                <meta name="twitter:creator" content="@marciamaio" />
                
                <link rel="canonical" href={seoUrl} />
                
                <script type="application/ld+json">
                    {JSON.stringify(combinedStructuredData, null, 2)}
                </script>
            </Helmet>
            {breadcrumbs.length > 0 && <BreadcrumbList items={breadcrumbs} />}
        </>
    );
};

export default SEO; 